import React, {useState} from 'react';
import ReactDOM from 'react-dom';

function CustomCheck2({checked, name, onChange}) {
    const [isCheck, setIsChecked] = useState(checked)

    const check = () => {
        setIsChecked(!isCheck)

        if(onChange) onChange(!isCheck)
    }
    return (
        <div className="custom-checkbox">
            <div className={["box", isCheck ? 'checked' : null].join(' ')}
                 onClick={check}
            ><div className="inside-box">&nbsp;</div></div>
            <input type="checkbox" name={name} defaultChecked={isCheck} readOnly className="checkbox-input" />
        </div>
    );
}

export default CustomCheck2;
